import React from 'react';
import classNames from "classnames";
import {NavLink} from "react-router-dom";

import {makeStyles} from "@material-ui/core/styles";

import ScrollAnimation from "react-animate-on-scroll";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";

import bg1 from "images/bg1.jpg";
import HeaderSectionStyle from "./HeaderSectionStyle";

const useStyles = makeStyles(HeaderSectionStyle);


const HeaderSection = () => {
    const classes = useStyles();
    console.log(classes);
    return (
        <div
            className={classes.pageHeader}
            style={{ backgroundImage: `url("${bg1}")` }}
        >
            <div className={classes.container}>
                <GridContainer>
                    <GridItem
                        xs={12}
                        sm={10}
                        md={7}
                        className={classNames(classes.mrAuto, classes.textLeft,)}
                    >
                        <ScrollAnimation animateIn="fadeInDown" duration={2} delay={0.3} animateOnce={true}>
                            <h1 className={classNames(classes.title, classes.titleStyle)}>
                                클라스카를 만나고,<br/>
                                내 노후의 클라스가 달라졌다
                            </h1>
                            <h4 className={classNames(classes.subTitleStyle)}style={{wordBreak: 'keep-all'}}>
                                사회가 가지고 있는 다양한 문제를 혁신적인 기술 또는 비즈니스 모델을 통해 해결하고 지속가능한 수익과 사회적 가치를 함께 추구하는 기업, 소셜벤처 클라스카입니다.
                            </h4>
                        </ScrollAnimation>
                        <br />
                        <div>
                            <NavLink to="/contact">
                                <ScrollAnimation animateIn="fadeInUpSmall" duration={2} delay={0.3} animateOnce={true}>
                                    <Button color="danger" size="lg">
                                        문의하기
                                    </Button>
                                </ScrollAnimation>
                            </NavLink>
                        </div>
                    </GridItem>
                </GridContainer>
            </div>
        </div>
    );
};

export default HeaderSection;
